import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
var ImpersonationGuardService = /** @class */ (function () {
    function ImpersonationGuardService(router) {
        this.router = router;
    }
    ImpersonationGuardService.prototype.canActivate = function () {
        return this.checkImpersonationFlag();
    };
    ImpersonationGuardService.prototype.canActivateChild = function () {
        return this.checkImpersonationFlag();
    };
    ImpersonationGuardService.prototype.checkImpersonationFlag = function () {
        var currentUser = localStorage.getItem('currentUser') && JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.hasOwnProperty('IsImpersonated') && String(currentUser.IsImpersonated).toLowerCase() === 'true') {
            this.router.navigate(['/login-impersonificado']);
        }
        return true;
    };
    ImpersonationGuardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ImpersonationGuardService_Factory() { return new ImpersonationGuardService(i0.ɵɵinject(i1.Router)); }, token: ImpersonationGuardService, providedIn: "root" });
    return ImpersonationGuardService;
}());
export { ImpersonationGuardService };
